<template>
  <div class="component-container">
    <h3>MSLNG1 Stability and Change in an Ecosystem - Downloads and Resources</h3>
    <div class="back-button-wrapper">
      <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
    </div>
    <div class="presentations">
      <h4>Teacher Presentations</h4>
      <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2FMSLNG1_Activities1-6_10142024.zip?alt=media&token=563f78ec-88d2-4171-bc4e-d550e3c22f67" target="_blank">Teacher Presentations: Activities 1 - 6 (Updated 10/14/2024)</a></li>
          
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
      <!-- <p style="margin-left: 40px;">Activities 4-6 Coming December 2022!</p> -->
    </div>
    <div class="presentations">
      <h4>Student Journals</h4>
      <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
      <ul>
        <li><a href="https://docs.google.com/presentation/d/1BUq5eQhZYe5uGt4Evl_18PMH8NVAupqCtqgclW9GAU8/copy" target="_blank">MSLNG1 Stability and Change in an Ecosystem Student Journal</a></li>
        <li><a href="https://drive.google.com/file/d/14taqSlBTsTIZzCUvyeX5JGcZFGHzRuDG/view" target="_blank">MSLNG1 Stability and Change in an Ecosystem Student Journal Answer Key</a></li>
      </ul>

    </div>
    <div class="presentations">
      <h4>Individual Resources</h4>
      <!-- <p>Coming October 2020!</p> -->
      <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1sUbot0udf46lfenHSpC3g8cAU8CupKWAb6nnELkvWws/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1x3R-SOY7E2X_wsfNwW4vB9GNEkA8wYmkrSUhkMx1OSM/copy" target="_blank">Fun Facts Handouts</a></li>
          <li><a href="https://docs.google.com/presentation/d/1U_qYK0gKsm5YarYzE_NCTgwbHdNk--WSYZiYoyCPYjU/copy" target="_blank">Classroom Ecosystem Observation Log</a></li>
          <li><a href="https://docs.google.com/presentation/d/1fYWImfhgGTCRIyqQxoOop3IbrcDLFyruobYC44NHQWs/copy" target="_blank">Classroom Anchor Charts</a></li>
          <li><a href="https://docs.google.com/presentation/d/1_VVPkxHvo64reD-B3sWvWIkpGgJMbwdsdIRx3OdkUCo/copy" target="_blank">Biodiversity Survey (Handout)</a></li>
          <li><a href="https://bit.ly/3QQSl4D" target="_blank">Biodiversity Survey (Google Form)</a></li>
          <li><a href="https://docs.google.com/presentation/d/14xSP7LHywcNeEYABeSKK6z8Rt6BLTpkcRS2Ktnj1XlU/copy" target="_blank">Graph Paper</a></li>
          <li><a href="https://docs.google.com/presentation/d/1VjeaGI2D-pZoP46ePrepmGseVpPns5w64_ZNqQYi8QM/copy" target="_blank">Wolf/Moose Relationship Product Descriptor (Handout)</a></li>
          <li><a href="https://docs.google.com/presentation/d/1HjGw23Ri2DoVaP1SZ7xKYWhZElJXqqWnrxWpuGlZk5M/copy" target="_blank">Word Sort Cards - Lesson 3A</a></li>
          <li><a href="https://docs.google.com/presentation/d/1DdebyV-fYOLx8mDpV_F8nuyszlzMYUHrmNlIUJ34sLw/copy" target="_blank">Isle Royale Population Chart (Handout)</a></li>
          <li><a href="https://docs.google.com/presentation/d/1LGAasF-IPqIGGmyO6eSm7BRJMNyhPH_jTP2GMymTrVQ/copy" target="_blank">Word Sort Cards - Lesson 5B</a></li>
          <li><a href="https://docs.google.com/presentation/d/18mt02IfLHeKgDefPKt_LwpgvvTyyMiwH-G8tbaZJ7go/copy" target="_blank">Word Sort Cards - Lesson 6C</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>
      <h4 style="margin-left: 10px;">Demonstration Videos</h4>
      <ul>
        <li><a href="https://drive.google.com/file/d/1q96TQNejvcWQcCxQTqDstVIkeRijq1vk/view?usp=share_link" target="_blank">MSLNG1 Classroom Habitat Set Up and Care</a></li>
        <li><a href="https://drive.google.com/file/d/1LrNpMYDKJZUzRM7PsyhDHl3X1Gk5Eh33/view?usp=share_link" target="_blank">MSLNG1 Creating a Wet Mount Slide</a></li>
        <li><a href="https://drive.google.com/file/d/1Dwe4iHhfn73r2jBfeU1HKnjAT2DfBQms/view?usp=share_link" target="_blank">MSLNG1 Using a Microscope</a></li>
      </ul>
    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>
